
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.service('Investments', function (Parse) {

		// ==================================================
		// Load object schema
		// ==================================================
		let Investment = Parse.Object.extend('Investments');

		// ==================================================
		// Methods
		// ==================================================

		/**
		 * Retrieve the list of Investments
		 */
		this.list = () => {
			let query = new Parse.Query(Investment);
			query.include('Project');
			query.select('amount', 'Project.title');
			return query.find();
		};


		/**
		 * Retrieve an Investment by ID
		 */
		this.get = id => {
			let query = new Parse.Query(Investment);
			return query.get(id);
		}
		
	});
}




// WEBPACK FOOTER //
// ./src/app/core/services/investments.service.js